export default __webpack_public_path__ + "static/media/spo2.4d6f20b7.png";